(ns frontend.view.components.autocomplete
  (:require-macros [frontend.macros :refer [without-default-action]])
  (:require [common.localization :as loc]
            [reagent.core :as r]
            [goog.events :as goog-events]))

(defn search! [state value key-fn search-fn add-fn input]
  (let [{:keys [cur-index]} @state]
    (swap! state
           assoc
           :raw-input
           input)
    (search-fn input
               (fn [results]
                 (swap! state
                        assoc
                        :results
                        results
                        :cur-index
                        (-> (keep-indexed (fn [index item]
                                            (if (= (key-fn item)
                                                   (key-fn value))
                                              index))
                                          results)
                            first
                            (or (if add-fn -1 0))))))))

(defn autocomplete [_]
  (let [state (r/atom nil)]
    (r/create-class
     {:component-did-mount
      (fn [this]
        (swap! state
               assoc
               :blur-emulator
               (goog-events/listen js/window
                                   "click"
                                   (fn [e]
                                     (swap! state dissoc :results)))))
      :component-will-unmount
      (fn [_]
        (goog-events/unlistenByKey (:blur-emulator @state)))
      :reagent-render
      (fn [{:keys [value placeholder on-change key-fn search-fn add-fn
                   value-component result-component]}]
        (let [{:keys [raw-input results cur-index]} @state
              select-fn (fn [value]
                          (swap! state dissoc :raw-input :results)
                          (on-change value))
              add-fn (if add-fn
                       (fn [input]
                         (swap! state dissoc :raw-input :results)
                         (add-fn raw-input)))
              search! (partial search!
                               state
                               value
                               key-fn
                               search-fn
                               add-fn)]
          [:div.zapflow-autocomplete
           [:div.zapflow-autocomplete-input
            {:class    (if results "zapflow-autocomplete-input--focus")
             :on-click (fn [e]
                         (.stopPropagation e)
                         (if-not results
                           (search! "")))}
            [:div.zapflow-autocomplete-input-value
             [value-component {:value value}]]
            [:input.zapflow-autocomplete-input__input
             {:type        "text"
              :value       raw-input
              :placeholder placeholder
              :on-change   (fn [e]
                             (if-not value
                               (let [input (-> e .-target .-value)]
                                 (search! input))))
              :on-key-down (fn [e]
                             (let [key (.-keyCode e)]
                               (cond

                                 (and (= key 8) value)
                                 (do (on-change nil)
                                     (search! ""))

                                 (= key 9)
                                 (swap! state dissoc :results)

                                 (= key 38)
                                 (without-default-action
                                  (if (or (and add-fn (>= cur-index 0))
                                          (> cur-index 0))
                                    (swap! state
                                           assoc
                                           :cur-index
                                           (dec cur-index))))

                                 (= key 40)
                                 (without-default-action
                                  (if (< cur-index
                                         (-> results count dec))
                                    (swap! state
                                           assoc
                                           :cur-index
                                           (inc cur-index))))

                                 (= key 13)
                                 (if (and (= cur-index -1)
                                          add-fn)
                                   (add-fn)
                                   (select-fn (nth results cur-index))))))}]]
           [:ul.zapflow-autocomplete-results
            {:class (if results
                      "zapflow-autocomplete-results--visible")}
            (concat
             [(if (and add-fn (not (empty? raw-input)))
                [:li.zapflow-autocomplete-result.zapflow-autocomplete-result--add
                 {:key      -1
                  :on-click add-fn
                  :class    (if (= cur-index -1)
                              "zapflow-autocomplete-result--selected")}
                 (str (loc/tr :add) " " raw-input)])]
             (doall (for [[index item] (map-indexed vector results)]
                      [:li.zapflow-autocomplete-result
                       {:key      (key-fn item)
                        :on-click #(select-fn item)
                        :class    (if (= cur-index index)
                                    "zapflow-autocomplete-result--selected")}
                       [result-component {:value item}]])))]]))})))
